// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"265":"4520937b","460":"a702ac21","727":"9490b47b"}[chunkId] + ".chunk.js";
};